module.exports = function getResource(label, vars=[]) {
    const resources = {
        free: 'FREE',
        biFreeShip: 'Beauty Insiders enjoy *FREE standard shipping* on all orders.',
        biFreeShipTest: `Your Order qualifies for *${vars[0]}.*`,
        biFreeShipTestVar: 'FREE standard shipping'
    };

    return resources[label];
};
